import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';

// import Multiselect from 'vue-multiselect'
// import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
    name: 'systemusers',
    components: {
        Paginate,
        VueElementLoading
    },
    data: function() {
        return {
            modalShow: false,
            updateusermodal: false,
            editusermodal: false,
            addusermodal: false,
            useraction: '',
            listUserData: [],
            listRoleData: [],
            props: [],
            pageno: 0,
            pagecount: 0,
            username: '',
            searchusername: '',
            searchemail: '',
            userid: '',
            rolename: '',
            isLoading: false,
            resultCount: '',
            adduser: {
                firstname: '',
                lastname: '',
                username: '',
                email: '',
                password: '',
                confirmpassword: '',
            },
            roleid: '',
            isactive: '',
            status: '',
            changestatus: '',
            count: 0,
            email: '',
            localuserid: 0
        }
    },
    created: function() {

    },
    mounted() {
        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.localuserid = userdetail.userid;
        this.localusermailid = userdetail.email;
        this.getUserData();
        this.getRoleList();
    },
    methods: {
        addNewUser() {
            this.userid = '',
            this.adduser.firstname = '',
            this.adduser.lastname = '',
            this.adduser.username = '',
            this.adduser.email = '',
            this.adduser.password = '',
            this.adduser.confirmpassword = '',
            this.isactive = 'true',
            this.roleid = '',
            this.useraction = 'add',
            this.addusermodal = true,
            this.$validator.reset();
            this.errors.clear();
        },
        closeAddUserModal() {
            $("#systemuserform").trigger("reset");
            this.addusermodal = false,
            this.$validator.reset();
            this.errors.clear();
        },
        closeStatusUserModal() {
            this.modalShow = false
        },
        searchUserData(){
          this.pageno = 0;
          this.$refs.paginate.selected = 0;
          this.getUserData();
        },
        getUserData() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');

            this.input = ({
                offset: this.pageno,
                limit: 10,
                firstname: this.searchusername,
                email: this.searchemail
            })
            this.isLoading = true;
            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'SystemUserMaster',
                    'data': this.input,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then(result => {
                    this.listUserData = result.data.data;
                    this.isLoading = false;
                    let totalRows = result.data.totalcount
                    this.resultCount = result.data.totalcount
                  
                    if (totalRows < 10) {
                        this.pagecount = 1
                    } else {
                        this.pagecount = Math.ceil(totalRows / 10)
                    }
                }, error => {
                    console.error(error)
                })
        },

        saveUser(event) {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            var username = this.adduser.username.replace(" ", '_');

            this.input = ({
                firstname: this.adduser.firstname,
                lastname: this.adduser.lastname,
                username: username,
                email: this.adduser.email,
                password: this.adduser.password,
                confirmpassword: this.adduser.confirmpassword,
                roleid: this.roleid,
                createdby: this.localusermailid,
                status: this.isactive
            })
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'SubmitSystemUserData',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
            .then((response) => {
                if (response.data.errorCode == 0) {
                    this.$alertify.success(response.data.msg);
                    this.addusermodal = false;
                    event.target.reset();
                    this.resetForm();
                } else if (response.data.errorCode == -1) {
                    this.$alertify.error(response.data.msg)
                }
            })
            .catch((httpException) => {
                console.error('exception is:::::::::', httpException)
            })
        },

        getUserRowData(data) {
            this.$validator.reset();
            this.errors.clear();
            this.useraction = 'edit';
            this.addusermodal = true;
            this.adduser.firstname = data.FirstName;
            this.adduser.lastname = data.LastName;
            this.adduser.username = data.username;
            this.adduser.email = data.email;
            this.adduser.password = data.password;
            this.roleid = data.roleid;
            this.adduser.password = data.password;
            this.userid = data.userid;
            this.isactive = data.status;
        },

        editUser(event) {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            var username = this.adduser.username.replace(" ", '_');

            this.input = ({
                userid: this.userid,
                firstname: this.adduser.firstname,
                lastname: this.adduser.lastname,
                username: username,
                email: this.adduser.email,
                roleid: this.roleid,
                modifiedby: this.localusermailid,
                status: this.isactive
            })
            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'updateSystemUser',
                    'data': this.input,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then((response) => {
                    if (response.data.errorCode == 0) {
                        this.$alertify.success(response.data.msg);
                        this.addusermodal = false;
                        event.target.reset();
                        this.resetForm();
                    } else if (response.data.errorCode == -1) {
                        this.$alertify.error(response.data.msg)
                    }
                })
                .catch((httpException) => {
                    console.error('exception is:::::::::', httpException)
                })
        },

        //to get pagination
        getPaginationData(pageNum) {
            this.pageno = (pageNum - 1) * 10
            this.getUserData()
        },
        //to get target id in active/inactive modal
        getStatusRowData(data) {
            this.Statusaction = 'add'
            this.modalShow = true
            this.userid = data.userid
            this.status = data.status
            if (data.status == true) {
                this.changestatus = 'De-Activate'
            } else {
                this.changestatus = 'Activate'
            }
        },
        //for active/inactive modal
        changeUserStatus() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');

            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'updateUserStatus',
                    'data': {
                        'userid': this.userid,
                        'status': this.status,
                    },
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then((response) => {
                    if (response.data.errorCode == 0) {
                        this.$alertify.success(response.data.msg);
                        this.addusermodal = false
                        this.getUserData()
                    } else if (response.data.errorCode == -1) {
                        this.$alertify.error(response.data.msg)
                    }
                })
                .catch((httpException) => {
                    console.error('exception is:::::::::', httpException)
                })
        },
        getRoleList() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            axios({
                    method: "POST",
                    'url': apiUrl.api_url + "getSystemRolesListData",
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then(result => {
                    this.listRoleData = result.data.rows;

                }, error => {
                    console.error(error)
                })
        },
        onSubmit: function(event) {
          this.$validator.validateAll().then((result) => {
            if(result){
              if(this.userid!=undefined && this.userid!=""){
                //console.log("Form ready to submit update user");
                this.editUser(event);
              }else{
                //console.log("Form ready to submit new user");
                this.saveUser(event);
              }
            }
          }).catch(() => {
            console.log('errors exist', this.errors)
          });
        },
        resetSearch(){
          this.searchusername = '';
          this.searchemail = '';
          this.pageno = 0;
          this.$refs.paginate.selected = 0;
          this.getUserData();
        },
        resetForm() {
            this.username = '';
            this.userid = '';
            this.email = '';
            this.adduser.firstname = '';
            this.adduser.lastname = '';
            this.adduser.username = '';
            this.adduser.email = '';
            this.adduser.password = '';
            this.adduser.confirmpassword = '';
            this.roleid = '';
            this.useraction = 'add';
            this.isactive = 'true';
            this.$validator.reset();
            this.errors.clear();
            this.getUserData();
        },
    }
}

Validator.extend('verify_email', {
  getMessage: field => "Only the e-mail address with @xpressbees.com",
  validate: value => {
      var idx = value.indexOf('@xpressbees.com');
      if (idx > -1) {
        return true;
      }else {
        return false;
      }
  }
});

Validator.extend('verifypassword', {
    getMessage: field => "The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, 1 special character and atleast 8 or more characters",
    validate: value => {
        var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
        return strongRegex.test(value);
    }
});



// WEBPACK FOOTER //
// ./src/views/components/systemusers/systemusers.component.js